// removed by extract-text-webpack-plugin
module.exports = {"modalFooter":"_2xWMpmSNKSNfhzc1wBLeS6","button":"_3DoqAboSyCZSGw9eP9aV2k","submitBtn":"xFrrukSGgBw2YA3_J0Hbd","clearBtn":"_2YVhFV_L_yN5yJmhwk8q8b"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ButtonsFormsControls/ButtonsFormsControls.scss
// module id = 1564
// module chunks = 0